/**
* @name APP ClassPanel
* @autor jaime.salazar@u-planner.com
* @description
* # name controller --> dialogSummaryControllers
* # As Controller --> dialogSummary
* brief comment controller for show dialog finish approval
                                                        
*/

export default class modalDetailsURtCtrl{

	constructor($http,$resource,$filter,ngNotify,$mdDialog){
        this.$mdDialog = $mdDialog;

        this.titles = {
            "teacherType": 'Nivel de promoción',
            "maxLevelFormationAchieved": 'Máximo nivel de formación alcanzada',
            "recognitionTypeGivenByUniversity": 'Experiencia reconocida',
            "nativeLanguage": 'Idioma nativo',
            "secondLanguage": 'Segundo idioma que certifica',
            "thirdLanguage": 'Tercer idioma que certifica',
            "fourthLanguage": 'Cuarto idioma que certifica',
            "rating": 'Producción académica acumulada',
            "pointsProvided": 'Puntos prestados de producción',
            "recognitionDate": 'Fecha de promoción',
            "record": 'Número de acta',
            "record_date": 'Fecha de acta',
            "recognitionMinistryEducation": 'Título de convalidación',
            "resolutionNumber": 'Número de resolucion',
            "convalidationDate": 'Fecha de convalidación',
            // "teacherCategory": 'Categoría de profesor',
            "observations": 'Observaciones',
            

        };

    }

    close(){
        this.$mdDialog.hide();
       //  this.$state.reload();
    }

    getKeys() {
	    return Object.keys(this.titles);
    }

    getTitle(key) {
        return this.titles[key] || 'desconocido';
    }
}

modalDetailsURtCtrl.$inject = [
                            '$http',
                            '$resource',
                            '$filter',
                            'ngNotify','$mdDialog'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/UR_trajectory/modalDetails/modalDetailsURtCtrl.js